import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dimensions, Pressable, Text, View } from "react-native";

import CorporationImage from "@/assets/corporation.svg";
import IndividualImage from "@/assets/individual.svg";

interface CardProps {
  title: string;
  body: string;
  onPress: (isPressed: boolean) => void;
  isSelected: boolean;
}

export default function Card(props: CardProps) {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const updateLayout = () => {
      const screenDimensions = Dimensions.get("window");
      setIsMobile(screenDimensions.width > 1024);
    };

    updateLayout();
    const subscription = Dimensions.addEventListener("change", updateLayout);
    return () => subscription.remove();
  }, []);

  const handlePress = () => {
    props.onPress(true);
  };

  return (
    <Pressable
      className={`p-4 w-64 h-fit bg-white1 rounded-xl border border-solid items-center justify-center my-2 mx-8 ${
        isHovered ? "border-purple5" : "border-midgray"
      } ${props.isSelected && "border-purple1"} lg:w-72 lg:h-96`}
      onPress={handlePress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <View className="flex-row items-center justify-center m-3">
        <Text className="text-2xl text-blue1 font-semibold">{props.title}</Text>
      </View>

      {isMobile &&
        (props.title === t("onboarding/welcome:card.corporation.title") ? (
          <CorporationImage />
        ) : props.title === t("onboarding/welcome:card.individual.title") ? (
          <IndividualImage />
        ) : null)}
      <View className="m-4">
        <Text className="text-center text-base">{props.body}</Text>
      </View>
    </Pressable>
  );
}
